module.exports = __webpack_public_path__ + "img/society2.d637bfec.png";